import React from "react";
import { Autocomplete, TextField, Chip, Box } from "@mui/material";
 
const AutoCompleteSearchField = ({
  selectedMetricOptions = [],
  setSelectedMetricOptions,
  metricOptions = [],
  placeholderName,
  style
}) => {
  const handleValueChange = (newValue) => {
    setSelectedMetricOptions([...newValue]);
  };
 
  const truncateLabel = (label) =>
    label.length > 5 ? `${label.slice(0, 5)}…` : label;
 
  return (
    <Autocomplete
      multiple
      value={selectedMetricOptions}
      onChange={(_e, newValue) => handleValueChange(newValue)}
      options={metricOptions}
      getOptionLabel={(option) => option?.value}
      sx={{
        width: 340,
        "& .MuiOutlinedInput-root": {
          height: 30,
          padding: "2px",
        },
        "& .MuiOutlinedInput-input": {
          fontSize: "12px",
          padding: "0 6px !important",
        },
        "& .MuiChip-root": {
          height: 22,
          fontSize: "11px",
          margin: "1px",
        },
        ...style
      }}
      renderTags={(value, getTagProps) => {
        const visibleChips = value.slice(0, 2);
        const hiddenCount = value.length - 2;
 
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {visibleChips.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                label={truncateLabel(option?.value)}
              />
            ))}
 
            {hiddenCount > 0 && (
              <Chip
                label={`+${hiddenCount}`}
                sx={{
                  height: 22,
                  fontSize: "11px",
                  marginLeft: "2px",
                }}
              />
            )}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholderName}  InputLabelProps={{
            shrink: true, // keeps label always on top
          }}/>
      )}
    />
  );
};
 
export default AutoCompleteSearchField;